import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["linkUri"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { RestClient } from '../rest-client';

/**
 * @type AllTeamsQuery
 * Query type for the getAllTeams API
 * @property {string} orgId - Organization ID
 * @property {string} cursor - Cursor to fetch the next page of results
 * @property {number} limit - Number of teams to fetch
 * @property {string} searchQuery - Search query to filter teams
 * @property {string[]} memberAccountIds - List of member account IDs to filter teams
 * @property {boolean} useDefaultSort - Whether to use the default sort order
 * @property {boolean} showEmptyTeams - Whether to return empty teams in the search
 */

/**
 * @type AllTeamsResponse
 * Response type for the getAllTeams API
 * @property {TeamWithMemberships[]} teams - List of teams
 * @property {string} cursor - Cursor to fetch the next page of results
 * @property {Error} error - Error object if the API call fails
 */

/**
 * @type AllTeamsPayload
 * Payload type for the getAllTeams API
 * @property {TeamWithMemberships[]} entities - List of teams
 * @property {string} cursor - Cursor to fetch the next page of results
 */

var v3UrlPath = "/v3/teams";
var v4UrlPath = "/v4/teams";

/**
 * REST Client to make calls to Legion.
 *
 * Redirects to the instance login screen when a response returns a 401.
 * It should probably redirect to Aa, but this is what the existing clients
 * do so I'm going to follow suite.
 */
export var LegionClient = /*#__PURE__*/function (_RestClient) {
  _inherits(LegionClient, _RestClient);
  var _super = _createSuper(LegionClient);
  function LegionClient(serviceUrl) {
    var _this;
    _classCallCheck(this, LegionClient);
    _this = _super.call(this, {
      serviceUrl: serviceUrl
    });
    _this.serviceUrlRoot = serviceUrl;
    return _this;
  }
  _createClass(LegionClient, [{
    key: "setRootUrl",
    value: function setRootUrl(url) {
      if (url === this.serviceUrlRoot) {
        return;
      }
      this.serviceUrlRoot = url;
      this.setServiceUrl(url);
    }
  }, {
    key: "getTeamById",
    value: function () {
      var _getTeamById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(teamId) {
        var siteId, teamResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              siteId = this.getCloudId();
              _context.next = 3;
              return this.getResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "?siteId=").concat(siteId));
            case 3:
              teamResponse = _context.sent;
              return _context.abrupt("return", this.mapTeamResponseV4ToTeam(teamResponse));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTeamById(_x) {
        return _getTeamById.apply(this, arguments);
      }
      return getTeamById;
    }()
  }, {
    key: "getAllTeams",
    value: function () {
      var _getAllTeams = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(allTeamsQuery) {
        var _this2 = this;
        var orgId, _siteId, _yield$this$postResou, entities, cursor, teams;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              orgId = this.getOrgId(allTeamsQuery.orgId);
              _siteId = this.getCloudId();
              _context2.next = 5;
              return this.postResource("".concat(v4UrlPath, "/search"), {
                organizationId: orgId,
                siteId: _siteId,
                limit: allTeamsQuery.limit,
                query: allTeamsQuery.searchQuery,
                cursor: allTeamsQuery.cursor || '',
                sortBy: allTeamsQuery.useDefaultSort ? null : [{
                  field: 'displayName',
                  order: 'asc'
                }],
                membership: {
                  memberAccountIds: allTeamsQuery.memberAccountIds
                },
                showEmptyTeams: allTeamsQuery.showEmptyTeams
              });
            case 5:
              _yield$this$postResou = _context2.sent;
              entities = _yield$this$postResou.entities;
              cursor = _yield$this$postResou.cursor;
              teams = entities.map(function (t) {
                return _this2.mapTeamSearchResponseV4ToTeamWithMembership(t);
              });
              return _context2.abrupt("return", {
                cursor: cursor,
                teams: teams
              });
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              this.logException(_context2.t0, 'getAllTeams');
              return _context2.abrupt("return", {
                cursor: '',
                teams: [],
                error: _context2.t0 instanceof Error ? _context2.t0 : undefined
              });
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 12]]);
      }));
      function getAllTeams(_x2) {
        return _getAllTeams.apply(this, arguments);
      }
      return getAllTeams;
    }()
  }, {
    key: "updateTeamById",
    value: function () {
      var _updateTeamById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(teamId, data) {
        var teamResponse;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.patchResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId)), data);
            case 2:
              teamResponse = _context3.sent;
              return _context3.abrupt("return", this.mapTeamResponseV4ToTeam(teamResponse));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function updateTeamById(_x3, _x4) {
        return _updateTeamById.apply(this, arguments);
      }
      return updateTeamById;
    }()
    /**
     * @private
     * @deprecated use publicApiClient.addUsersToTeam instead
     */
  }, {
    key: "inviteUsersToTeam",
    value: (function () {
      var _inviteUsersToTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(teamId, users, originQuery) {
        var emails, ids, url;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!users || users.length === 0)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", Promise.resolve([]));
            case 2:
              emails = [];
              ids = [];
              users.forEach(function (user) {
                if (user.id) {
                  ids.push(user.id);
                } else if (user.email) {
                  emails.push(user.email);
                }
              });
              url = "".concat(v3UrlPath, "/ui/").concat(this.trimTeamARI(teamId), "/membership/invite?").concat(this.constructProductOriginParams(originQuery));
              return _context4.abrupt("return", this.postResource(url, {
                emailAddresses: emails,
                atlassianAccounts: ids
              }));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function inviteUsersToTeam(_x5, _x6, _x7) {
        return _inviteUsersToTeam.apply(this, arguments);
      }
      return inviteUsersToTeam;
    }())
  }, {
    key: "getMyTeamMembership",
    value: function () {
      var _getMyTeamMembership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(teamId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", this.getResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/membership/me?siteId=").concat(this.getCloudId()), {
                shouldLogError: function shouldLogError(e) {
                  return e.status !== 400;
                }
              }));
            case 1:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getMyTeamMembership(_x8) {
        return _getMyTeamMembership.apply(this, arguments);
      }
      return getMyTeamMembership;
    }()
  }, {
    key: "getTeamLinksByTeamId",
    value: function () {
      var _getTeamLinksByTeamId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(teamId) {
        var siteId, response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              siteId = this.getCloudId();
              _context6.next = 3;
              return this.getResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/links?siteId=").concat(siteId));
            case 3:
              response = _context6.sent;
              return _context6.abrupt("return", this.mapLegionTeamLinksResponseV4ToTeamLinkResponse(response));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getTeamLinksByTeamId(_x9) {
        return _getTeamLinksByTeamId.apply(this, arguments);
      }
      return getTeamLinksByTeamId;
    }()
  }, {
    key: "createTeamLink",
    value: function () {
      var _createTeamLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(teamId, link) {
        var sanitisedTeamLink, response;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              sanitisedTeamLink = _objectSpread(_objectSpread({
                contentTitle: link.contentTitle.trim(),
                linkUri: link.linkUri.trim(),
                description: link.description.trim()
              }, link.creationTime ? {
                creationTime: link.creationTime.trim()
              } : {}), link.teamId ? {
                teamId: link.teamId.trim()
              } : {});
              _context7.next = 3;
              return this.postResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/links"), sanitisedTeamLink);
            case 3:
              response = _context7.sent;
              return _context7.abrupt("return", this.mapLegionTeamLinkResponseV4ToTeamLink(response));
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function createTeamLink(_x10, _x11) {
        return _createTeamLink.apply(this, arguments);
      }
      return createTeamLink;
    }()
  }, {
    key: "updateTeamLink",
    value: function () {
      var _updateTeamLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(teamId, linkId, _ref) {
        var linkUri, linkFields, response;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              linkUri = _ref.linkUri, linkFields = _objectWithoutProperties(_ref, _excluded);
              _context8.next = 3;
              return this.putResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/links/").concat(linkId), _objectSpread({
                linkUri: linkUri.trim()
              }, linkFields));
            case 3:
              response = _context8.sent;
              return _context8.abrupt("return", this.mapLegionTeamLinkResponseV4ToTeamLink(response));
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function updateTeamLink(_x12, _x13, _x14) {
        return _updateTeamLink.apply(this, arguments);
      }
      return updateTeamLink;
    }()
  }, {
    key: "deleteTeamLink",
    value: function () {
      var _deleteTeamLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(teamId, linkId) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", this.deleteResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/links/").concat(linkId)));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function deleteTeamLink(_x15, _x16) {
        return _deleteTeamLink.apply(this, arguments);
      }
      return deleteTeamLink;
    }()
  }, {
    key: "reorderTeamLink",
    value: function () {
      var _reorderTeamLink = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(teamId, linkId, newPosition) {
        var queryArgs;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              queryArgs = "?linkId=".concat(linkId, "&newPosition=").concat(newPosition);
              return _context10.abrupt("return", this.postResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/links/order").concat(queryArgs)));
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function reorderTeamLink(_x17, _x18, _x19) {
        return _reorderTeamLink.apply(this, arguments);
      }
      return reorderTeamLink;
    }()
    /**
     * @private
     * @deprecated in V4, as no invitation status for team membership anymore.
     */
  }, {
    key: "acceptTeamInvitation",
    value: (function () {
      var _acceptTeamInvitation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(teamId) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.postResource("".concat(v3UrlPath, "/ui/").concat(this.trimTeamARI(teamId), "/membership/accept")));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function acceptTeamInvitation(_x20) {
        return _acceptTeamInvitation.apply(this, arguments);
      }
      return acceptTeamInvitation;
    }()
    /**
     * @private
     * @deprecated in V4, as no invitation status for team membership anymore.
     */
    )
  }, {
    key: "declineTeamInvitation",
    value: (function () {
      var _declineTeamInvitation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(teamId) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", this.postResource("".concat(v3UrlPath, "/ui/").concat(this.trimTeamARI(teamId), "/membership/decline")));
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function declineTeamInvitation(_x21) {
        return _declineTeamInvitation.apply(this, arguments);
      }
      return declineTeamInvitation;
    }())
  }, {
    key: "selfJoinTeam",
    value: function () {
      var _selfJoinTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(
      // TODO Test me
      teamId, originQuery) {
        var url;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              url = "".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/membership/join?").concat(this.constructProductOriginParams(originQuery));
              return _context13.abrupt("return", this.postResource(url));
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function selfJoinTeam(_x22, _x23) {
        return _selfJoinTeam.apply(this, arguments);
      }
      return selfJoinTeam;
    }()
  }, {
    key: "cancelJoinRequest",
    value: function () {
      var _cancelJoinRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(teamId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", this.deleteResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/membership/request")));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function cancelJoinRequest(_x24) {
        return _cancelJoinRequest.apply(this, arguments);
      }
      return cancelJoinRequest;
    }()
  }, {
    key: "acceptJoinRequest",
    value: function () {
      var _acceptJoinRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(teamId, memberId) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", this.postResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/membership/").concat(memberId, "/request/accept")));
            case 1:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function acceptJoinRequest(_x25, _x26) {
        return _acceptJoinRequest.apply(this, arguments);
      }
      return acceptJoinRequest;
    }()
  }, {
    key: "declineJoinRequest",
    value: function () {
      var _declineJoinRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(teamId, memberId) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", this.postResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/membership/").concat(memberId, "/request/decline")));
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function declineJoinRequest(_x27, _x28) {
        return _declineJoinRequest.apply(this, arguments);
      }
      return declineJoinRequest;
    }()
    /**
     * @private
     * @deprecated use publicApiClient.removeTeamMemberships instead
     */
  }, {
    key: "deleteTeamMembership",
    value: (function () {
      var _deleteTeamMembership = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(teamId, memberId) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", this.deleteResource("".concat(v3UrlPath, "/").concat(this.trimTeamARI(teamId), "/members/").concat(memberId)));
            case 1:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function deleteTeamMembership(_x29, _x30) {
        return _deleteTeamMembership.apply(this, arguments);
      }
      return deleteTeamMembership;
    }()
    /**
     * @private
     * @deprecated INVITED status has been deprecated
     */
    )
  }, {
    key: "revokeTeamInvite",
    value: (function () {
      var _revokeTeamInvite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(teamId, memberId) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", this.deleteResource("".concat(v3UrlPath, "/ui/").concat(this.trimTeamARI(teamId), "/membership/").concat(memberId, "/revoke")));
            case 1:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function revokeTeamInvite(_x31, _x32) {
        return _revokeTeamInvite.apply(this, arguments);
      }
      return revokeTeamInvite;
    }())
  }, {
    key: "deleteTeam",
    value: function () {
      var _deleteTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(teamId) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", this.deleteResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId))));
            case 1:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function deleteTeam(_x33) {
        return _deleteTeam.apply(this, arguments);
      }
      return deleteTeam;
    }()
    /**
     * @private
     * @deprecated should be other means to solve this issue
     */
  }, {
    key: "isSingleFullMemberTeam",
    value: (function () {
      var _isSingleFullMemberTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(teamId) {
        var members;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return this.getResource("".concat(v4UrlPath, "/").concat(this.trimTeamARI(teamId), "/members?size=2&membershipState=FULL_MEMBER&siteId=").concat(this.getCloudId()));
            case 2:
              members = _context20.sent;
              return _context20.abrupt("return", members.entities.length === 1);
            case 4:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function isSingleFullMemberTeam(_x34) {
        return _isSingleFullMemberTeam.apply(this, arguments);
      }
      return isSingleFullMemberTeam;
    }())
  }, {
    key: "createTeam",
    value: function () {
      var _createTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(displayName, originQuery, members) {
        var membershipSettings,
          organizationId,
          err,
          url,
          legionTeam,
          _args21 = arguments;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              membershipSettings = _args21.length > 3 && _args21[3] !== undefined ? _args21[3] : 'OPEN';
              organizationId = this.getContext().orgId;
              if (organizationId) {
                _context21.next = 6;
                break;
              }
              err = new Error('Organization ID is required');
              this.logException(err, 'createTeam');
              throw err;
            case 6:
              url = "".concat(v4UrlPath, "?").concat(this.constructProductOriginParams(originQuery));
              _context21.next = 9;
              return this.postResource(url, {
                displayName: displayName,
                description: '',
                membershipSettings: membershipSettings,
                siteId: this.getCloudId(),
                organizationId: organizationId,
                members: _toConsumableArray(new Set(members))
              });
            case 9:
              legionTeam = _context21.sent;
              return _context21.abrupt("return", this.mapTeamCreateResponseV4ToTeam(legionTeam));
            case 11:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function createTeam(_x35, _x36, _x37) {
        return _createTeam.apply(this, arguments);
      }
      return createTeam;
    }()
  }, {
    key: "createExternalTeam",
    value: function () {
      var _createExternalTeam = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(description, externalReference, teamName, siteId) {
        var organizationId, cloudId, err, url, legionExternalTeam;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              organizationId = this.getContext().orgId;
              cloudId = this.getContext().cloudId;
              if (organizationId) {
                _context22.next = 6;
                break;
              }
              err = new Error('Organization ID is required');
              this.logException(err, 'createTeam');
              throw err;
            case 6:
              url = "".concat(v4UrlPath, "/external?origin.cloudId=").concat(encodeURIComponent(this.getCloudId(siteId || cloudId)));
              _context22.next = 9;
              return this.postResource(url, {
                description: description,
                externalReference: externalReference,
                organizationId: organizationId,
                siteId: siteId || cloudId,
                displayName: teamName
              });
            case 9:
              legionExternalTeam = _context22.sent;
              return _context22.abrupt("return", this.mapTeamCreateResponseV4ToTeam(legionExternalTeam));
            case 11:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function createExternalTeam(_x38, _x39, _x40, _x41) {
        return _createExternalTeam.apply(this, arguments);
      }
      return createExternalTeam;
    }()
  }, {
    key: "getWriteMediaToken",
    value: function () {
      var _getWriteMediaToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", this.getResource('/v4/teams/header-image/media-upload').then(function (response) {
                var _response$baseUrl;
                return _objectSpread(_objectSpread({}, response), {}, {
                  baseUrl: (_response$baseUrl = response.baseUrl) !== null && _response$baseUrl !== void 0 && _response$baseUrl.endsWith('/') ? response.baseUrl.slice(0, -1) : response.baseUrl
                });
              }));
            case 1:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function getWriteMediaToken() {
        return _getWriteMediaToken.apply(this, arguments);
      }
      return getWriteMediaToken;
    }()
  }, {
    key: "getSoftDeletedTeamById",
    value: function () {
      var _getSoftDeletedTeamById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(teamId) {
        var orgId, siteId;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              orgId = this.getOrgId();
              siteId = this.getCloudId();
              return _context24.abrupt("return", this.getResource("".concat(v4UrlPath, "/org/").concat(orgId, "/soft-deleted/").concat(this.trimTeamARI(teamId), "?siteId=").concat(siteId)).then(function (response) {
                return _objectSpread(_objectSpread({}, response.teamResponse), {}, {
                  id: teamId
                });
              }));
            case 3:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function getSoftDeletedTeamById(_x42) {
        return _getSoftDeletedTeamById.apply(this, arguments);
      }
      return getSoftDeletedTeamById;
    }()
    /**
     * Shoud only be used within Teams (P&T) packages
     */
  }, {
    key: "getUserInSiteUserBase",
    value: (function () {
      var _getUserInSiteUserBase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(userId) {
        var siteId;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              siteId = this.getCloudId();
              return _context25.abrupt("return", this.getResource("/teams/site/".concat(siteId, "/users/").concat(userId, "/exists"), {
                headers: {
                  Accept: 'application/json',
                  'X-header-client-id': 'ptc-fe'
                }
              }));
            case 2:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function getUserInSiteUserBase(_x43) {
        return _getUserInSiteUserBase.apply(this, arguments);
      }
      return getUserInSiteUserBase;
    }())
  }, {
    key: "retrieveBrowseUserPermission",
    value: function () {
      var _retrieveBrowseUserPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(product) {
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              return _context26.abrupt("return", this.getResourceCached("/teams/site/".concat(this.getCloudId(), "/canSearchUsers?product=").concat(product), undefined,
              // 2 minute expiration, resolves duplicate calls in initial load
              {
                expiration: 1000 * 60 * 2
              }));
            case 1:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function retrieveBrowseUserPermission(_x44) {
        return _retrieveBrowseUserPermission.apply(this, arguments);
      }
      return retrieveBrowseUserPermission;
    }()
  }, {
    key: "getPermissions",
    value: function () {
      var _getPermissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var orgId, siteId, err;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              orgId = this.getContext().orgId;
              siteId = this.getCloudId();
              if (orgId) {
                _context27.next = 6;
                break;
              }
              err = new Error('Organization ID is required');
              this.logException(err, 'getPermissions');
              throw err;
            case 6:
              return _context27.abrupt("return", this.getResourceCached("".concat(v4UrlPath, "/permission/self/organization/").concat(orgId, "?siteId=").concat(siteId)));
            case 7:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function getPermissions() {
        return _getPermissions.apply(this, arguments);
      }
      return getPermissions;
    }()
  }, {
    key: "getLinkedTeamsBulk",
    value: function () {
      var _getLinkedTeamsBulk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(groupIds) {
        var organizationId, err, legionExternalTeam;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              organizationId = this.getContext().orgId;
              if (organizationId) {
                _context28.next = 5;
                break;
              }
              err = new Error('Organization ID is required');
              this.logException(err, 'getLinkedTeamsBulk');
              throw err;
            case 5:
              _context28.next = 7;
              return this.postResource("".concat(v4UrlPath, "/external/bulk"), {
                organizationId: organizationId,
                source: 'ATLASSIAN_GROUP',
                externalIds: groupIds
              });
            case 7:
              legionExternalTeam = _context28.sent;
              return _context28.abrupt("return", legionExternalTeam);
            case 9:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this);
      }));
      function getLinkedTeamsBulk(_x45) {
        return _getLinkedTeamsBulk.apply(this, arguments);
      }
      return getLinkedTeamsBulk;
    }()
  }, {
    key: "getTeamProfileDetails",
    value: function () {
      var _getTeamProfileDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(teamId) {
        var siteId, err, linkedTeamsProfileDetails;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              siteId = this.getCloudId();
              if (siteId) {
                _context29.next = 5;
                break;
              }
              err = new Error('Site ID is required');
              this.logException(err, 'getTeamProfileDetails');
              throw err;
            case 5:
              _context29.next = 7;
              return this.getResource("".concat(v4UrlPath, "/").concat(teamId, "/profile?siteId=").concat(this.getCloudId()));
            case 7:
              linkedTeamsProfileDetails = _context29.sent;
              return _context29.abrupt("return", linkedTeamsProfileDetails);
            case 9:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function getTeamProfileDetails(_x46) {
        return _getTeamProfileDetails.apply(this, arguments);
      }
      return getTeamProfileDetails;
    }()
  }, {
    key: "getOrgScope",
    value: function () {
      var _getOrgScope = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var orgId, err, orgScope;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              orgId = this.getContext().orgId;
              if (orgId) {
                _context30.next = 5;
                break;
              }
              err = new Error('Organization ID is required');
              this.logException(err, 'getOrgScope');
              throw err;
            case 5:
              _context30.next = 7;
              return this.getResourceCached("".concat(v4UrlPath, "/org/").concat(orgId, "/scope"));
            case 7:
              orgScope = _context30.sent;
              return _context30.abrupt("return", orgScope);
            case 9:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function getOrgScope() {
        return _getOrgScope.apply(this, arguments);
      }
      return getOrgScope;
    }() // some Legion APIs return team id with the team ARI
  }, {
    key: "trimTeamARI",
    value: function trimTeamARI() {
      var teamId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var OLD_TEAM_ARI_PREFIX = 'ari:cloud:teams::team/';
      var TEAM_ARI_PREFIX = 'ari:cloud:identity::team/';
      return teamId.replace(TEAM_ARI_PREFIX, '').replace(OLD_TEAM_ARI_PREFIX, ''); // PTC-4213 will remove the references to the old team ARI
    }
  }, {
    key: "constructProductOriginParams",
    value: function constructProductOriginParams(originQuery) {
      var product = (originQuery.product || '').toUpperCase();
      var queries = ["origin.cloudId=".concat(encodeURIComponent(this.getCloudId(originQuery.cloudId)))];
      if (product) {
        queries.push("origin.product=".concat(encodeURIComponent(product)));
      }
      return queries.join('&');
    }
  }, {
    key: "mapTeamResponseV4ToTeam",
    value: function mapTeamResponseV4ToTeam(teamResponse) {
      return {
        id: teamResponse.id,
        displayName: teamResponse.displayName,
        description: teamResponse.description,
        state: teamResponse.state,
        membershipSettings: teamResponse.membershipSettings,
        organizationId: teamResponse.organizationId,
        restriction: 'ORG_MEMBERS',
        // Deprecated field, not used in UI - this is the safest default
        creatorId: teamResponse.creatorId,
        permission: teamResponse.permission,
        orgId: teamResponse.organizationId,
        smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
        largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
        smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
        largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
        scopeMode: teamResponse.scopeMode,
        isVerified: teamResponse.isVerified
      };
    }
  }, {
    key: "mapTeamCreateResponseV4ToTeam",
    value: function mapTeamCreateResponseV4ToTeam(teamResponse) {
      var _teamResponse$members;
      return {
        id: teamResponse.id,
        displayName: teamResponse.displayName,
        description: teamResponse.description,
        state: teamResponse.state,
        membershipSettings: teamResponse.membershipSettings,
        organizationId: teamResponse.organizationId,
        restriction: 'ORG_MEMBERS',
        // Deprecated field, not used in UI - this is the safest default
        creatorId: teamResponse.creatorId,
        permission: teamResponse.permission,
        orgId: teamResponse.organizationId,
        memberIds: ((_teamResponse$members = teamResponse.membership) === null || _teamResponse$members === void 0 || (_teamResponse$members = _teamResponse$members.members) === null || _teamResponse$members === void 0 ? void 0 : _teamResponse$members.map(function (m) {
          return m.membershipId.memberId;
        })) || [],
        membership: teamResponse.membership
      };
    }
  }, {
    key: "mapTeamSearchResponseV4ToTeamWithMembership",
    value: function mapTeamSearchResponseV4ToTeamWithMembership(teamResponse) {
      return {
        id: teamResponse.id,
        displayName: teamResponse.displayName,
        description: teamResponse.description,
        state: teamResponse.state,
        membershipSettings: teamResponse.membershipSettings,
        organizationId: teamResponse.organizationId,
        restriction: 'ORG_MEMBERS',
        // Deprecated field, not used in UI - this is the safest default
        smallHeaderImageUrl: teamResponse.smallHeaderImageUrl,
        largeAvatarImageUrl: teamResponse.largeAvatarImageUrl,
        smallAvatarImageUrl: teamResponse.smallAvatarImageUrl,
        largeHeaderImageUrl: teamResponse.largeHeaderImageUrl,
        memberCount: teamResponse.memberCount,
        includesYou: teamResponse.includesYou,
        memberIds: [],
        // Team Search API does not return members
        members: [],
        // Team Search API does not return members
        membership: {
          members: [],
          errors: []
        }
      };
    }
  }, {
    key: "mapLegionTeamLinksResponseV3ToTeamLinkResponse",
    value: function mapLegionTeamLinksResponseV3ToTeamLinkResponse(response) {
      return {
        entities: response.entities.map(this.mapLegionTeamLinkResponseV3ToTeamLink)
      };
    }
  }, {
    key: "mapLegionTeamLinksResponseV4ToTeamLinkResponse",
    value: function mapLegionTeamLinksResponseV4ToTeamLinkResponse(response) {
      return {
        entities: response.entities.map(this.mapLegionTeamLinkResponseV4ToTeamLink)
      };
    }
  }, {
    key: "mapLegionTeamLinkResponseV3ToTeamLink",
    value: function mapLegionTeamLinkResponseV3ToTeamLink(legionLinkResponseV3) {
      return {
        contentTitle: legionLinkResponseV3.contentTitle,
        description: legionLinkResponseV3.description,
        creationTime: legionLinkResponseV3.creationTime,
        linkUri: legionLinkResponseV3.linkUri,
        linkId: legionLinkResponseV3.linkId,
        teamId: legionLinkResponseV3.teamId
      };
    }
  }, {
    key: "mapLegionTeamLinkResponseV4ToTeamLink",
    value: function mapLegionTeamLinkResponseV4ToTeamLink(legionLinkResponseV4) {
      return {
        contentTitle: legionLinkResponseV4.contentTitle,
        description: legionLinkResponseV4.description,
        linkUri: legionLinkResponseV4.linkUri,
        linkId: legionLinkResponseV4.linkId,
        teamId: legionLinkResponseV4.teamId
      };
    }
  }]);
  return LegionClient;
}(RestClient);
export var defaultLegionClient = new LegionClient(DEFAULT_CONFIG.stargateRoot);